import React, { ReactNode } from 'react';
import './TabWrapper.scss';

export const TabWrapper = ({ children }: { children: ReactNode }) => {
  return <div className="TabWrapper">{children}</div>;
};
